/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MeasValueType = {
    String: 'String',
    Boolean: 'Boolean',
    Long: 'Long',
    Double: 'Double',
    Profile: 'Profile',
    Pdd: 'PDD',
    Mcc: 'MCC',
    Xcc: 'XCC',
    UserDefined: 'UserDefined'
} as const;
export type MeasValueType = typeof MeasValueType[keyof typeof MeasValueType];


export function MeasValueTypeFromJSON(json: any): MeasValueType {
    return MeasValueTypeFromJSONTyped(json, false);
}

export function MeasValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasValueType {
    return json as MeasValueType;
}

export function MeasValueTypeToJSON(value?: MeasValueType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the MeasValueType interface.
 */
 export function instanceOfMeasValueType(value: any): value is MeasValueType {
    return Object.values(MeasValueType).includes(value)
}

